<template>
  <div class="table_wrap" v-if="showLayout">
    <div class="c_table_wrap table_search_wrap">
      <div class="filter-push-div">
        <span class="filter-select-span mr24">검색</span>
        <el-input
            class="table_s_input search-input mr5"
            v-model="searchInput"
            size=""
            placeholder="검색어를 입력해주세요."
            maxLength="40"
            @input="setSearchInput(searchInput)"
        >
        </el-input>
        <el-button class="search-button" @click="setSearchInput(searchInput)">
          검색
        </el-button>
      </div>

    </div>
    <el-table class="list-table" header-cell-class-name="list-header" :data="option" ref="livingTimeTable"
              style="width: 100%;" height="500" empty-text="데이터가 없습니다." @selection-change="tableSelectChange">
      <el-table-column label="거주 시간대" class-name="text-center" prop="t_timezone">
      </el-table-column>
      <el-table-column width="100" class-name="text-center" label="옵션">
        <template slot-scope="scope">
          <el-radio v-model="setTimeValue" :label="scope.row.t_idx" :value="scope.row.t_idx" @change="tableSelectChange(scope.row)">
             {{``}}
          </el-radio>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import util from "@/mixins/util";
import dateMixins from "@/mixins/dateMixins";

let searchSetTimeout = null;
export default {
  name: "SetLivingTimeLayout",
  mixins: [dateMixins],
  inject: ['pushTypeSetData'],
  components: {},
  provide() {
    return {}
  },
  props: {
    setData: {default: () => []},
    paginationData: {
      default: () => { return { total: 0, page: 0, size: 0, }}
    },
    originData : {
      type : Object
    }

  },
  data() {
    return {
      // selectArr: [],
      searchInput: '',
      setTimeValue : '',
      option : [],
      showLayout:false,
    }
  },
  created() {
    this.initState();
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods: {
    initState(){
      this.option = this.setData;
      this.setTimeValue = this.originData.time[0]
      this.parentChange('time',this.originData.time);
      this.showLayout= true;
    },
    tableSelectChange(row) {
      this.selectArr = [];
      util.Array.each(row, (obj, index, arr) => {
        this.selectArr.push(obj.t_idx);
      });
      this.setTimeValue = this.selectArr[0];
      this.parentChange('time',this.selectArr);
      this.parentChange('offTime',row['t_offset']);
    },
    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
    parentChange(key,value){
      this.pushTypeSetData(key, value)
    },
    setSearchInput(text) {
      this.searchInput = text;
      if (searchSetTimeout != null) {
        clearTimeout(searchSetTimeout);
        searchSetTimeout = null;
      }
      searchSetTimeout = setTimeout(() => {
        this.startSearch(this.searchInput);
        searchSetTimeout = null;
      }, 300);
    },

    startSearch(query) {
      let dictionary = this.setData
      if(query === ''){
        this.option = dictionary
      }else{
        let result = dictionary.filter(
            (value) => value.t_timezone.toLowerCase().indexOf(query.toLowerCase()) > -1
        )
        this.option = result;
      }
    },

  },
  watch: {
    'setData' : {
      deep:true,
      handler: function (val, oldVal) {
        if(val !== oldVal){
          this.option = this.setData;
        }
      },
    }
  },
}
</script>

<style scoped>

</style>